import { ITabData } from '../../Component/DataGrid/Interface';
import { PartnerPermissions } from "../../Component/Permissions/PermissionsInterface.";

export interface ILiquidityPartner {
  liquidityPartnerId: string;
  liquidityPartnerName: string;
  isActive: number;
  createdDate: string;
  totalPageCount: number;
}

export interface IPayOutPartner {
  payoutPartnerId: string;
  payoutPartnerName: string;
  isActive: number;
  createdDate: string;
  totalPageCount: number;
}

export interface PartnerState {
  accessToken: string;
  partner: PartnerPermissions;
  liquidityPartnerList: ILiquidityPartner[];
  payOutPartnerList: IPayOutPartner[]
  isOpenAddLiquidityPartnerDialog: boolean;
  isOpenAddPayoutPartnerDialog: boolean;
  isOpenUpdateLiquidityPartnerDialog: boolean;
  isOpenUpdatePayoutPartnerDialog: boolean;
  selectedLiquidityPartner: ILiquidityPartner | null;
  selectedPayoutPartner: IPayOutPartner | null;
  //filter and pagenation
  currentRowsPerPage: number;
  currentPage: number;
  totalRows: number;
  searchText: string;
  filterValue: string;
  selectedKey: String;
  userID: string;
  selectedTab: number;
  paginationReset: boolean;
  tabData: ITabData[];
}

export enum TabsPartners {
  Liquidity,
  Payout
}

//string enums cannot be reverse mapped, so there is no option, but to create duplicate enum to hold names
export enum TabsPartnersNames {
  Liquidity = "Liquidity Partner",
  Payout = "Payout Partner"
}
export enum TabsPartnersWidths {
  Liquidity = 170,
  Payout = 170
}

//Interface for Partner component props
export interface PartnerProps {
}
